<template>
  <v-card
    class="mx-auto info-card"
    flat
  >
    <v-toolbar short flat>
      <v-toolbar-title>
        <v-icon class="toolbar-icon">mdi-weather-sunny</v-icon>
        {{ `Solaris ${app_data.title}` }}
      </v-toolbar-title>
    </v-toolbar>
    <div class="info-card-content">
      <!-- DIVISAO -->
      <v-subheader class="font-weight-regular pt-2 mx-1">
        {{ lang.config.app.title }}
      </v-subheader>
      <template>
        <v-card-subtitle class="px-4 py-0">
          {{ lang.config.app.info.edition }}
        </v-card-subtitle>
        <v-card-text class="text--primary font-weight-light pt-0 pb-1 px-4">
          <div>{{ app_data.edition }}</div>
        </v-card-text>
      </template>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.app.info.version }}
        </v-card-subtitle>
        <v-card-text class="text--primary font-weight-light pt-0 pb-1">
          <div>{{ app_data.ver }}</div>
        </v-card-text>
      </template>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.app.info.address }}
        </v-card-subtitle>
        <v-card-text class="text--primary font-weight-light pt-0 pb-1">
          <div>{{ `${app_data.app_protocol}://${app_data.app_server}` }}</div>
        </v-card-text>
      </template>
      <template v-if="app_data.dev_mode">
        <v-card-subtitle class="pb-0 pt-0 dev-mode">
          <v-progress-circular
            :value="100"
            :size="9"
            color="amber"
            class="server-status"
          ></v-progress-circular>
          {{ lang.config.app.info.dev_mode }}
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" class="notification-alert">
                <v-icon small color="red">mdi-exclamation-thick</v-icon>
              </v-btn>
            </template>
            <span v-html="lang.config.app.info.dev_mode_info"></span>
          </v-tooltip>
        </v-card-subtitle>
      </template>
      <!-- DIVISAO -->
      <v-subheader class="font-weight-regular mt-2 mx-1">
        {{ lang.config.app.info.license.title }}
      </v-subheader>
      <template v-if="license_info">
        <template>
          <v-card-subtitle class="pb-0 pt-0">
            {{ lang.config.app.info.license.domain }}
          </v-card-subtitle>
          <v-card-text class="text--primary font-weight-light pt-0 pb-1">
            <div>{{ app_data.generic_license.domain }}</div>
          </v-card-text>
        </template>
        <template v-if="app_data.generic_license.company">
          <v-card-subtitle class="pb-0 pt-0">
            {{ lang.config.app.info.license.company }}
          </v-card-subtitle>
          <v-card-text class="text--primary font-weight-light pt-0 pb-1">
            <div>{{ `${app_data.generic_license.company.name} - ${app_data.generic_license.company.cnpj}` }}</div>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-subtitle class="pb-0 pt-0">
            {{ lang.config.app.info.license.holder }}
          </v-card-subtitle>
          <v-card-text class="text--primary font-weight-light pt-0 pb-1">
            <div>{{ `${app_data.generic_license.holder.name} - ${app_data.generic_license.holder.cpf}` }}</div>
          </v-card-text>
        </template>
      </template>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.app.info.license.status.title }}
        </v-card-subtitle>
        <v-card-text class="text--primary font-weight-light pt-0 pb-1">
          <div>
            <v-progress-circular
              :color="(license_info ? license_info.color : 'red')"
              :value="100"
              :size="9"
              class="server-status"
            ></v-progress-circular>
            {{ (license_info ? (license_info.last > 0 ? `${license_info.last} ${lang.config.app.info.license.status.last}` : lang.config.app.info.license.status.expired) : lang.config.app.info.license.status.invalid) }}
          </div>
        </v-card-text>
      </template>
      <!-- DIVISAO -->
      <v-subheader class="font-weight-regular mt-2 mx-1">
        {{ lang.config.app.info.server }}
      </v-subheader>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.app.info.address }}
        </v-card-subtitle>
        <v-card-text class="text--primary font-weight-light pt-0 pb-1">
          <div>{{ app_data.socket_server }}</div>
        </v-card-text>
      </template>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.app.info.status.title }}
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-progress-circular
                v-on="on"
                :color="(socketInfo.isConnected ? 'green' : 'amber')"
                :value="100"
                :size="9"
                class="ml-1 server-status"
              ></v-progress-circular>
            </template>
            <span>{{ (socketInfo.isConnected ? lang.config.app.info.status.online : lang.config.app.info.status.offline) }}</span>
          </v-tooltip>
        </v-card-subtitle>
      </template>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.app.info.internet.title }}
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-progress-circular
                v-on="on"
                :color="(socketInfo.isOnline ? 'green' : 'amber')"
                :value="100"
                :size="9"
                class="ml-1 server-status"
              ></v-progress-circular>
            </template>
            <span>{{ (socketInfo.isOnline ? lang.config.app.info.internet.online : lang.config.app.info.internet.offline) }}</span>
          </v-tooltip>
        </v-card-subtitle>
      </template>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.app.info.auth.title }}
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-progress-circular
                v-on="on"
                :color="(socketInfo.isLogged ? 'green' : 'amber')"
                :value="100"
                :size="9"
                class="ml-1 server-status"
              ></v-progress-circular>
            </template>
            <span>{{ (socketInfo.isLogged ? lang.config.app.info.auth.online : lang.config.app.info.auth.offline) }}</span>
          </v-tooltip>
        </v-card-subtitle>
      </template>
      <!-- DIVISAO -->
    </div>
  </v-card>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  computed: {
    license_info: function () {
      let license = this.app_data.generic_license
      if (license) {
        const day = 24 * 60 * 60 * 1000
        let now = new Date()
        let until = new Date(Date.parse(this.mysqlDatetimeConvert(license.until)))
        let last = Math.round(Math.abs((until - now) / day))
        let color = (last > 0 ? (last > 7 ? 'green' : 'amber') : 'red')
        return { color, last }
      }
      return false
    }
  }
}
</script>
